import { ActiveNavTab, getActiveNavTab } from "./utils/activeNavTab";
import { ReactNode, createContext, useContext, useMemo } from "react";

type ActiveNavTabContextValue = {
  activeTab: ActiveNavTab;
};

const ActiveNavTabContext = createContext<ActiveNavTabContextValue | null>(null);

type ActiveNavTabProviderProps = {
  pathname: string;
  children: ReactNode;
};

export function ActiveNavTabProvider({ pathname, children }: ActiveNavTabProviderProps) {
  const value = useMemo(
    () => ({
      activeTab: getActiveNavTab(pathname),
    }),
    [pathname]
  );
  return <ActiveNavTabContext.Provider value={value}>{children}</ActiveNavTabContext.Provider>;
}

export function useActiveNavTab(): ActiveNavTabContextValue {
  const context = useContext(ActiveNavTabContext);
  if (!context) {
    throw new Error("useActiveNavTab must be used within ActiveNavTabProvider");
  }
  return context;
}
